<template>
  <div class="container">

    <div class="toppanel">
        <div class="segment">
            <div class="item active">用户评价</div>
            <div class="item" @click="goto('/review/gallery')">服务图集</div>
        </div>

<!--         <div class="title">用户评价</div>
 -->
        <div class="filter">
            <div class="pill" :class="{ active: serviceFilter=='all'}" @click="serviceFilter='all';scrollToTop()">全部服务</div>
            <div class="pill" :class="{ active: serviceFilter=='move'}" @click="serviceFilter='move';scrollToTop()">搬家服务</div>
            <div class="pill" :class="{ active: serviceFilter=='clean'}" @click="serviceFilter='clean';scrollToTop()">清洁服务</div>
            <div class="pill" :class="{ active: serviceFilter=='other'}" @click="serviceFilter='other';scrollToTop()">其他服务</div>
        </div>   
    </div>


    <div class="reviews" >
        <div class="item" v-for="reviews in reviewData">
            <div class="date" v-if="ifShowDate(reviews.count)">{{reviews.date}}</div>
            <div class="cell" v-for="review in reviews.info" v-if="serviceFilter=='all' || serviceFilter==review.type_name">
                <div class="icon" v-if="review.star==1">
                    <div class="image"><img src='../../assets/img/review/good.svg'></div>
                    <div class="txt">满意</div>
                </div>
                <div class="icon" v-if="review.star==2">
                    <div class="image"><img src='../../assets/img/review/bad.svg'></div>
                    <div class="txt">一般</div>
                </div>
                <div class="text" >
                    <div class="metadata clearfix">
                        <div class="username">用户{{review.member_phone}}</div>
                        <div class="time">{{review.time}}</div>
                        <div class="service" @click="goto('/move-step1')" v-if="review.type_name=='move'"><img src="../../assets/img/review/icon/move.svg"> 搬家 <span class="icon-chevron-right"></span></div>
                        <div class="service" @click="goto('/cleanex/guide')" v-else-if="review.type_name=='clean'"><img src="../../assets/img/review/icon/clean.svg"> 清洁 <span class="icon-chevron-right"></span></div>
                        <div class="service" v-else><img src="../../assets/img/review/icon/other.svg"> {{review.cn_type_name}}</div>
                    </div>
                    <div class="comment">
                        {{review.content}}
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-if="!reviewStop&&reviewData.length>0" class="more" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <i role="img" aria-label="加载中" class="weui-loading"></i><br>
        正在加载 
    </div>

    <div v-if="reviewStop" class="more">
        您已读完所有用户评价
    </div>

    <transition name="fade">
        <div id="loadingToast" v-show="isSending && reviewData.length==0 ">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在加载评论</p>
            </div>
        </div>
    </transition>

  </div>

</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import anime from 'animejs';

export default {
  name: 'review',
  data () {
    return {
      isSending:false,
      reviewData:[],
      reviewStop:false,
      serviceFilter:'all',
      currentDate:'',
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      } // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    }
  },
  created: function () {
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    ifShowDate(mass){
        if(this.serviceFilter=='all'){
            return true
        }
        else if(mass[this.serviceFilter]>0){
            return true
        }
        else{
            return false
        }
    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 300,
            easing = arg.easing || 'easeInSine',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToTop(){
        this.scroll({
            to: '.toppanel'
        });
    },
    getPricing(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;
        let url = this.apiURL()+'/TradeRate/list';
        let apiObject = {};

        let newDay = new Date();
        let oldDay = new Date();

        if(this.currentDate){
            newDay = this.currentDate;
        }

        var oldDay = newDay - 1000 * 60 * 60 * 24 * 60;  
        oldDay = new Date(oldDay);

        apiObject.start_at = Vue.filter('moment')(oldDay,"YYYY-MM-DD");
        apiObject.end_at = Vue.filter('moment')(newDay,"YYYY-MM-DD");


        this.axios.post(url,qs.stringify(apiObject))
        .then(function (response) {
            if(response.data.data.length>0){
                if(that.reviewData.length>0){
                    that.reviewData = that.reviewData.concat(response.data.data);
                }
                else{
                    that.reviewData = response.data.data;
                }
                that.isSending = false;
                that.currentDate = oldDay;
            }
            else{
                that.reviewStop = true;
                that.isSending = false;
            }

        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
      }
    },
    onWaypoint ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        this.getPricing();
      }

    }
  }
}

</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
    padding-top:100px;
}

.more{
    text-align:center;
    font-size:0.9em;
    color:#777;
}

.toppanel{
  position:fixed;
  left:0;
  top:0;
  padding-top:20px;
  width:100%;
  z-index:99;
  background:#fff;
  border-bottom:1px solid #f3f3f3;
}

.reviews{
    padding:15px;
    .item{
        .date{
            font-size:1.3em;
            font-weight:bold;
            margin:20px 0 10px 0;
            color:#555;
        }
        .cell{
            display: flex;
            justify-content:space-between;
            margin-bottom:26px;
            .icon{
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                flex: 1;
                text-align:center;
                color:$color-orange;
                padding-right:8px;
                .image{
                    font-size:0;
                }
                .txt{
                    font-size:0.9em;
                }
            }
            .text{
                -webkit-box-flex: 6;
                -webkit-flex: 6;
                flex: 6;
                .metadata{
                    font-size:0.8em;
                    color:#aaa;
                    .username{float:left}
                    .time{float:left; margin-left:30px;}
                    .service{
                        float:right;
                        img{
                            width:12px;
                        }
                    }
                }
                .comment{
                    margin-top:10px;
                    min-height:54px;
                    box-sizing:border-box;
                    background:$color-orange;
                    background-image: linear-gradient(90deg, #ff9260 0%, $color-orange 100%);
                    padding:13px;
                    color:#fff;
                    -webkit-border-radius: 16px;
                    -webkit-border-top-left-radius: 0;
                    -moz-border-radius: 16px;
                    -moz-border-radius-topleft: 0;
                    border-radius: 16px;
                    border-top-left-radius: 0;
                }
            }
        }
    }
}

.filter{
    padding:12px 12px 15px 12px;
    display: flex;
    justify-content:space-around;
    .pill{
        display:inline-block;
        font-size:0.8em;
        background:#f6f6f6;
        padding:4px 12px;
        border-radius:20px;
        &.active{
            color:$color-orange;
            background:#fff0ee;
            font-weight:bold;
        }
    }
}


.title{
    font-size:16pt;
    padding:0;
}

.segment{
    background:#f5f5f5;
    border-radius:50px;
    width:70%;
    margin:0 auto;
    height:40px;
    display: flex;
    justify-content:space-between;
    margin-top:4px;
    .item{
        width:50%;
        text-align:center;
        font-size:1.2em;
        line-height:2.1em;
        font-weight:bold;
        color:#999;
        &.active{
            background:#ff7444;
            color:#fff;
            border-radius:50px;
            background-size: cover;
        }
    }
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.vehicle-img img{
    max-width:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/comment.vue